<div class="compact-stages-wrapper">

    @if(!stageMode()) {

    <div class="totals-block">
        <div class="totals-title">Prosjekt totalt</div>
        <div class="totals-body">
            <div class="units-label">
                <div class="label">ENHETER</div>
                <div class="count">{{ projectTotals()?.totalUnits | number:'1.0-0' | dash }}</div>
            </div>

            <div>
                <div class="bar-row">
                    <span class="label">SOLGT</span>
                    <span class="count">{{ projectTotals()?.totalSoldUnits | number:'1.0-0' | dash }}</span>
                    <ev-progress-bar width="100%" height="10px" [progress]="projectTotals()?.precentageSold"
                        [theme]="projectTotals()?.precentageSold == 1 ? 'green' : 'blue'"></ev-progress-bar>
                </div>
                <div class="bar-row">
                    <span class="label">USOLGT</span>
                    <span class="count">{{ projectTotals()?.totalUnsoldUnits | number:'1.0-0' | dash }}</span>
                    <ev-progress-bar width="100%" height="10px" [progress]="projectTotals()?.precentageUnsold"
                        theme="grey" direction="right"></ev-progress-bar>
                </div>

            </div>
        </div>
    </div>
    }

    @for (stage of stages(); track stage.projectStageEstateTypeId) {
    <div class="stage-block">
        @if(!stageMode()) {
            <div class="stage-header">
                <div class="icon" [class]="'property-' + stage.estateTypeCssString"></div>
                <a class="stage-name"
                    href="/infopage/newdwelling/project/?pid={{ projectInfo()?.unitId }}&pseid={{ stage.projectStageEstateTypeId }}">
                    @if (stage.saleStateType === EVNDSaleStateType.Withdrawn) {
                    <span class="withdrawn">Trukket</span>
                    }
                    {{ stage.stageName }}
                </a>
            </div>
        }
        
        @if (stage?.saleStart != null) {
            <div class="sale-start">Salgsstart {{ stage?.saleStart | date:'MMMM yyyy' }}</div>
        }

        <div class="stage-body">
            <div class="units-label">
                <div class="label">ENHETER</div>
                <div class="count">{{ stage.totalUnits | number:'1.0-0' | dash }}</div>
            </div>
            <div>
                <div class="bar-row">
                    <span class="label">SOLGT</span>
                    <span class="count">{{ stage.totalSoldUnits | number:'1.0-0' | dash }}</span>
                    <ev-progress-bar width="100%" height="10px" [progress]="stage.precentageSold"
                        [theme]="stage.precentageSold == 1 ? 'green' : 'blue'"></ev-progress-bar>
                </div>
                <div class="bar-row">
                    <span class="label">USOLGT</span>
                    <span class="count">{{ stage.totalUnsoldUnits | number:'1.0-0' | dash }}</span>
                    <ev-progress-bar width="100%" height="10px" [progress]="stage.precentageUnsold" theme="grey"
                        direction="right"></ev-progress-bar>
                </div>

            </div>
        </div>
    </div>
    }

</div>